module.exports = __webpack_public_path__ + "static/media/man-queue.0a30a640.png";